import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, type Observable } from 'rxjs';

import type { ApiResultV2 } from '@malou-io/package-utils';

import { environment } from ':environments/environment';
import { saveJwtTokenToLocalStorage } from ':shared/utils/jwt-token-local-storage-functions';

@Injectable({
    providedIn: 'root',
})
export class AuthHttpService {
    readonly API_BASE_URL = `${environment.APP_MALOU_API_URL}/api/v1`;

    private readonly _http = inject(HttpClient);

    public login(params: { email: string; password: string }): Observable<ApiResultV2<{ token: string }>> {
        return this._http.post<ApiResultV2<{ token: string }>>(`${this.API_BASE_URL}/users/login`, params).pipe(
            map((res) => {
                saveJwtTokenToLocalStorage(res.data.token);
                return res;
            })
        );
    }

    public isTokenValid$(jwtToken: string): Observable<ApiResultV2<boolean>> {
        return this._http
            .get<ApiResultV2<boolean>>(`${this.API_BASE_URL}/users/is-token-valid`, {
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            })
            .pipe(map((res) => res));
    }
}
